import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import CardActions from './components/CardActions.js';
import CardButton from './components/CardButton.js';
import CardButtonLayout from './components/CardButtonLayout.js';
import CardContent from './components/CardContent.js';
import CardHeading from './components/CardHeading.js';
import CardIcon from './components/CardIcon.js';
import CardImage from './components/CardImage.js';
import CardLink from './components/CardLink.js';
import CardSection from './components/CardSection.js';
import CardText from './components/CardText.js';
import CardWrapper from './components/CardWrapper.js';

const Wrapper = (props)=>'href' in props ? /*#__PURE__*/ React.createElement("a", swcHelpers.extends({}, props), props.children) : /*#__PURE__*/ React.createElement("div", swcHelpers.extends({}, props))
;
/** Base component for constructing a layered card */ const Card = (_param)=>{
    var { layout ='vertical' , children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "layout",
        "children",
        "className"
    ]);
    const isLink = 'href' in rest;
    return /*#__PURE__*/ React.createElement(Wrapper, swcHelpers.extends({
        className: classnames('card-base', `card-base--${layout}`, className, {
            'card-base--with-link': isLink
        })
    }, rest), React.Children.map(children, (child)=>{
        if (!/*#__PURE__*/ React.isValidElement(child)) return child;
        /**
         * Need to add class to CardImage so Card can target it without reaching
         * inside of CardImage to know its root class.
         */ if (child.type === CardImage) {
            return /*#__PURE__*/ React.createElement(CardImage, swcHelpers.extends({}, child.props, {
                className: classnames(child.props.className, 'card-base__image')
            }));
        }
        /**
         * Render "link" variant of CardContent if Card is rendering as a link.
         * This will show the chevron in CardContent, indicating that the entire
         * card can be clicked and functions as a link.
         */ if (isLink && child.type === CardContent) {
            return /*#__PURE__*/ React.createElement(CardContent, swcHelpers.extends({}, child.props, {
                variant: "link"
            }));
        }
        return child;
    }));
};
Card.Actions = CardActions;
Card.Button = CardButton;
Card.ButtonLayout = CardButtonLayout;
Card.Content = CardContent;
Card.Heading = CardHeading;
Card.Icon = CardIcon;
Card.Image = CardImage;
Card.Link = CardLink;
Card.Section = CardSection;
Card.Text = CardText;
Card.OldCard = CardWrapper;

export { Card as default };
//# sourceMappingURL=Card.js.map
